<template>
  <TextBlock
    v-if="!media"
    :id="item?.fields.id ?? `section-${item.sys.id}`"
    :cols="mappedCols"
    :cols-centered="item.fields.textCenteredInRow"
    :content-centered="item.fields.textCentered"
    :lead="item.fields.textLeadStyle"
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'text'
      })
    "
  >
    <LibRichTextRenderer
      v-if="item.fields.text"
      :rich-text="item.fields.text"
    />
  </TextBlock>
  <TextMediaBlock
    v-if="media"
    :id="item?.fields.id ?? `section-${item.sys.id}`"
    :media="media"
    :text-side="item.fields.textPosition ?? 'left'"
    :text-lead="item.fields.textLeadStyle ?? false"
    :text-centered="true"
    :offset-media-left="item.fields.offsetMediaLeft ?? false"
    :offset-media-right="item.fields.offsetMediaRight ?? false"
    :offset-text-left="item.fields.offsetTextLeft ?? false"
    :offset-text-right="item.fields.offsetTextRight ?? false"
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'text'
      })
    "
  >
    <LibRichTextRenderer
      v-if="item.fields.text"
      :rich-text="item.fields.text"
    />
  </TextMediaBlock>
</template>

<script setup lang="ts">
import { TextBlock, TextMediaBlock } from '@hypercodestudio/basler-components';
import LibRichTextRenderer from '~/components/global/lib/RichTextRenderer.vue';
import type { ITextMedia } from '~~/lib/ContentfulService';
import { useMedia } from '~/composables/useMedia';
import { useProgressiveMedia } from '~/composables/useProgressiveMedia';
import { mapColsWidth } from '~/utils/mapColsWidth';
import { textMediaImageOptions } from '~/utils/imagePresetRegistry';
import type { IMedia } from '~/utils/guards/isMediaType';
const { $ContentfulLivePreview } = useNuxtApp();

interface Props {
  item: ITextMedia;
}

const props = defineProps<Props>();

const baseMedia = await useMedia(props.item.fields.media as IMedia, {
  ...textMediaImageOptions
});

const { media } = useProgressiveMedia(baseMedia);

const mappedCols = computed(() => mapColsWidth(props.item.fields.textWidth));
</script>
